export default __webpack_public_path__ + "static/media/aws.dd9277c9.svg";